(function (Drupal) {
  Drupal.behaviors.positionBody = {
    attach: function (context, settings) {
      // Ajuste dinámico del body
      function ajustePosicion() {
        let header = document.querySelector("#header");
        let nav = document.querySelector("#block-subtheme-keralty-navegacionprincipal-2");
        let main = document.querySelector("#main-wrapper");

        if (header && nav && main) {
          let heightHeaderNav;
          if (header.getBoundingClientRect().height === 0) {
            const navbar = document.querySelector("#navbar-main");

            heightHeaderNav = navbar.getBoundingClientRect().height;
          } else {
            heightHeaderNav = header.getBoundingClientRect().height + nav.getBoundingClientRect().height;
          }
          if (!document.querySelector("body").classList.contains("path-frontpage")) {
            main.style.paddingTop = heightHeaderNav + "px";
          }

          // Comprobar si es la página de inicio y si el ancho de la pantalla es <= 768px
          const isHomePage = window.location.pathname === "/";
          const isMobileScreen = window.innerWidth >= 992;

          if (isHomePage && isMobileScreen) {
            main.style.paddingTop = heightHeaderNav + "px";
          }
        }
      }

      // Llamar a la función para ajustar la posición
      ajustePosicion();

      // Volver a ajustar si la pantalla cambia de tamaño
      window.addEventListener("resize", ajustePosicion);
    },
  };
})(Drupal);
